import * as moment from 'moment';
import { Entity } from '@decahedron/entity';

export default class User extends Entity {
    public id: string = null;

    public firstname: string = null;

    public lastname: string = null;

    public email: string = null;

    public password: string = null;

    public role: string = null;

    public blockedAt: string = null;

    public get name(): string {
        return `${this.firstname || ''} ${this.lastname || ''}`;
    }

    public setBlocked() {
        this.blockedAt = moment.default().format('YYYY-MM-DD');
    }
}
